import {Component, Input, OnInit} from "@angular/core";

/** DEPRECATED **/

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

    @Input() error: boolean;
    @Input() errorHeader: string;
    @Input() errorMessage: string;
    @Input() errorResponseCode: string;

    validationMessages = {
        'generic': {
            'required': 'This field is required',
            'minlength': 'This field is too short',
            'min': 'This field is too small',
            'maxlength': 'This field is too long',
            'max': 'This field is too large',
            'email': 'Please enter a valid email',
            'number': 'Please enter a valid number',
            'pattern': 'Invalid input',
            'url': 'Please enter a valid url',
            'date': 'Please enter a valid date',
            'datetimelocal': 'Please enter a valid date and time',
            'time': 'Please enter a valid time',
            'week': 'Please enter a valid week',
            'month': 'Please enter a valid month'
        }
    };

    ngOnInit() {
        // had to add this or the template doesn't respect errorResponseCode?.length
        if (this.errorResponseCode) {
            this.errorResponseCode = this.errorResponseCode.toString();
        }
    }
}
